import { render, staticRenderFns } from "./mobile-app-modal.vue?vue&type=template&id=8a313a40&scoped=true&"
import script from "./mobile-app-modal.vue?vue&type=script&lang=js&"
export * from "./mobile-app-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a313a40",
  null
  
)

export default component.exports